import React from 'react';
import Modal from '../shared/Modal';
import { serviceAPI } from '../../InterfaceAPI/serviceAPI';
import Spinner from '../shared/Spinner';

class SendMenuSmsReminder extends React.Component {
  state = {
    isSending: false,
  };

  render() {
    const { isOpen, closeModal, service } = this.props;
    const client = service.client;

    return (
      <Modal isOpen={isOpen} onRequestClose={closeModal}>
        <div className="admin-wrapper">
          <h2 className="h2 modal__heading">
            Send Menu Selection Reminder Text
          </h2>
          {client ? (
            <div className="form__row">
              Send Menu Selection Reminder SMS to client {client.name} (
              {client.phone_number})?
            </div>
          ) : (
            <div className="form__row">Please select a client first</div>
          )}
          <div className="form__row">
            <div className="form__row-item--half">
              <div
                className="btn btn--hollow-red-bright btn--full-width"
                onClick={closeModal}
              >
                Cancel
              </div>
            </div>
            <div className="form__row-item--half">
              <input
                type="submit"
                className="btn btn--solid-blue btn--full-width"
                disabled={!client}
                value="Send Text"
                onClick={this.handleSubmit}
              />
            </div>
            <Spinner isRequestOut={this.state.isSending}></Spinner>
          </div>
        </div>
      </Modal>
    );
  }

  componentDidMount() {
    const { service } = this.props;
    this.setState({ disabled: !service.client });
  }

  handleSubmit = () => {
    const { service } = this.props;
    this.setState({ isSending: true });
    serviceAPI
      .sendSmsReminder(service.id)
      .then(() => {
        this.props.addMessage({
          className: 'success',
          message: 'SMS sent successfully',
        });
        this.props.closeModal();
        this.setState({ isSending: false });
      })
      .catch((err) => {
        this.props.addMessage({
          className: 'error',
          message: `Error sending SMS: ${err}`,
        });
        this.props.closeModal();
        this.setState({ isSending: false });
        console.log(err);
      });
  };
}

export default SendMenuSmsReminder;



// WEBPACK FOOTER //
// ./src/components/client/SendMenuSmsReminder.js